import JobItem from "../jobItem/JobItem";
import { Link } from "react-router-dom";
import { useGetJobsQuery } from "../../store/query/jobs";
import { useMemo } from "react";
import { useTypedSelector } from "../../hook/useTypedSelector";
import usePublicDivision from "../../hook/usePublicDivision";
import { Bars } from "react-loader-spinner";

const AllJobsItem = () => {
  const { user } = useTypedSelector((store) => store.appUser);
  const { divisonList } = usePublicDivision();
  const findSingleDivision =
    useMemo(() => {
      return divisonList?.find((i) => i.label === user?.division?.name);
    }, [divisonList, user]) || null;

  const { data: jobs, isLoading } = useGetJobsQuery(
    user ? { division: findSingleDivision?.value } : {}
  );
  //console.log("jobs", jobs);

  if (isLoading) {
    return (
      <div className="pag-screen">
        <Bars
          height="40"
          width="40"
          color=" #245293"
          ariaLabel="bars-loading"
          wrapperStyle={{}}
          wrapperClass=""
          visible={true}
        />
      </div>
    );
  }

  return (
    <div>
      <div className="proxy-job-container">
        {jobs?.data?.allJob?.data?.length === 0 ? (
          <p className="no-jobs-found"> No Jobs Found! </p>
        ) : (
          <div className="job-result-container">
            {jobs?.data?.allJob?.data?.slice(0, 3).map((job) => {
              return (
                <Link
                  to={`/joblistings/${job.id}`}
                  key={job.id}
                  className="findJobs-jobitem"
                >
                  <JobItem
                    title={job.title}
                    rate={job.hourly_rate}
                    jobLoc={`${job.city}, ${job.state}`}
                    jobDesc={`${job.description.slice(0, 100)} ...`}
                    jobOrg={job.company_name}
                    jobImg={job.logo}
                    count={500}
                  />
                </Link>
              );
            })}
          </div>
        )}
      </div>

      {jobs?.data?.allJob?.data?.length > 0 && (
        <div className="button-full">
          <Link className="job-view-more" to="/joblistings">
            View More
          </Link>
        </div>
      )}
    </div>
  );
};

export default AllJobsItem;
